"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '2 2 22 22';

var Terminal = function Terminal() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M20,2.5H5C3.622,2.5,2.5,3.621,2.5,5v15c0,1.379,1.122,2.5,2.5,2.5h15c1.378,0,2.5-1.121,2.5-2.5V5 C22.5,3.621,21.378,2.5,20,2.5z M5,3.5h15c0.827,0,1.5,0.673,1.5,1.5v3.5h-18V5C3.5,4.173,4.173,3.5,5,3.5z M20,21.5H5 c-0.827,0-1.5-0.673-1.5-1.5V9.5h18V20C21.5,20.827,20.827,21.5,20,21.5z"
  }), _react["default"].createElement("path", {
    d: "M6,6.5h2c0.276,0,0.5-0.224,0.5-0.5S8.276,5.5,8,5.5H6C5.724,5.5,5.5,5.724,5.5,6S5.724,6.5,6,6.5z"
  }), _react["default"].createElement("path", {
    d: "M10,6.5h2c0.276,0,0.5-0.224,0.5-0.5S12.276,5.5,12,5.5h-2C9.724,5.5,9.5,5.724,9.5,6S9.724,6.5,10,6.5z"
  }), _react["default"].createElement("path", {
    d: "M10.354,12.646c-0.195-0.195-0.512-0.195-0.707,0l-3,3c-0.195,0.195-0.195,0.512,0,0.707l3,3 C9.744,19.451,9.872,19.5,10,19.5s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L7.707,16l2.646-2.646 C10.549,13.158,10.549,12.842,10.354,12.646z"
  }), _react["default"].createElement("path", {
    d: "M15.354,12.646c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707L17.293,16l-2.646,2.646 c-0.195,0.195-0.195,0.512,0,0.707C14.744,19.451,14.872,19.5,15,19.5s0.256-0.049,0.354-0.146l3-3 c0.195-0.195,0.195-0.512,0-0.707L15.354,12.646z"
  }));
};

var svgProps = {
  viewBox: viewBox
};

var _default = (0, _createSvgIcon["default"])(Terminal, svgProps);

exports["default"] = _default;